import { render, staticRenderFns } from "./Predicates.vue?vue&type=template&id=58491ee0&scoped=true&"
import script from "./Predicates.vue?vue&type=script&lang=js&"
export * from "./Predicates.vue?vue&type=script&lang=js&"
import style0 from "./Predicates.vue?vue&type=style&index=0&id=58491ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58491ee0",
  null
  
)

export default component.exports